const scrollToTop = (scrollBehavior) => {
  const behavior = scrollBehavior ? scrollBehavior : 'auto';
  window.scroll({
    top: 0,
    behavior: behavior
  });
};
export default scrollToTop;